import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Container, Grid, Table, Alert, Snackbar, tableCellClasses, Button, Box, IconButton, InputLabel, Select, MenuItem, Dialog, DialogActions, DialogTitle, DialogContent } from '@mui/material';
import { z } from "zod";
import { FormModal, RHFTextField } from "../components/form";
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import api, { fetchDispatchNewInstallations, updateDispatchNewInstallation, emailDispatchNewInstallationPdf, generateDispatchNewInstallationPdf, fetchCustomers, fetchSolutions, fetchProductionNewInstallation } from "../services/ApiService";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import DeleteConfirmDialog from '../components/DeleteConfirmDialog';
import SendEmailConfirmDialog from '../components/SendEmailConfirmDialog';
import CircularProgress from '@mui/material/CircularProgress';
import DataTable from '../components/DataTable';

export function Store() {
    const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' }); // Snackbar state
        const [saleModalOpen, setSaleModalOpen] = React.useState(false);
        const [selectedSale, setSelectedSale] = React.useState(null);
        const [haulierOptions, setHaulierOptions] = React.useState([]);
            const [truckOptions, setTruckOptions] = React.useState([]);
            const [devicesOptions, setDevicesOptions] = React.useState([]);
                const [sendingEmailId, setSendingEmailId] = React.useState(null);
                const [deleteConfirmOpen, setDeleteConfirmOpen] = React.useState(false);
const [sendConfirmOpen, setSendConfirmOpen] = React.useState(false);
const [selectedActionSaleId, setSelectedActionSaleId] = React.useState(null);

// Open delete confirmation
const handleDeleteClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setDeleteConfirmOpen(true);
};

// Confirm delete
const confirmDelete = async () => {
    if (selectedActionSaleId) {
        await handleDelete(selectedActionSaleId);
    }
    setDeleteConfirmOpen(false);
    setSelectedActionSaleId(null);
};

// Open send email confirmation
const handleSendClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setSendConfirmOpen(true);
};

// Confirm send email
const confirmSendEmail = async () => {
    if (selectedActionSaleId) {
        await handleSendEmail(selectedActionSaleId);
    }
    setSendConfirmOpen(false);
    setSelectedActionSaleId(null);
};

    const handleSendEmail = async (saleId) => {
        setSendingEmailId(saleId);

        try {
            await emailDispatchNewInstallationPdf(saleId, {});
            alert("Email sent successfully!");
        } catch (error) {
            console.error("Email error:", error);
            alert("Failed to send email.");
        } finally {
            setSendingEmailId(null);
        }
    };
    const fetchDevices = async () => {
        try {
          const response = await fetchSolutions();
          const deviceDict = response.data.reduce((acc, item) => {
            acc[item.id] = item.name;
            return acc;
          }, {});
          setDevicesOptions(deviceDict)
          showSnackbar('Hauliers fetched successfully', 'success');
        } catch (error) {
          const errorMessage =
            error.response?.statusText || error.message || 'Error fetching hauliers';
          showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
        }
      };
      const handleViewCustomerSupportDetail = async (saleId) => {
              try {
                  const response = await fetchProductionNewInstallation(saleId);
                  console.log(response.data);

                  setSelectedSale(response.data);
                  setSaleModalOpen(true);
              } catch (error) {
                  console.error("Failed to fetch sale detail:", error);
              }
          };
      const fetchHauliers = async () => {
        try {
            const response = await fetchCustomers();
            const haulierDict = response.data.reduce((acc, item) => {
                acc[item.id] = item.name;
                return acc;
            }, {});
            console.log(haulierDict);

            setHaulierOptions(haulierDict)
            showSnackbar('Hauliers fetched successfully', 'success');
        } catch (error) {
            const errorMessage =
                error.response?.statusText || error.message || 'Error fetching hauliers';
            showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
        }
    };
    const fetchTrucks = async () => {
        try {
            const response = await fetchDispatchNewInstallations();
            setStoreData(response.data);
            showSnackbar('Store fetched successfully', 'success');
        } catch (error) {
            const errorMessage =
                error.response?.statusText || error.message || 'Error fetching Store';
            showSnackbar(`Failed to fetch Store: ${errorMessage}`, 'error');
        }
    };

    React.useEffect(() => {
        fetchTrucks();
        fetchHauliers()
        fetchDevices()
    }, []);
    const handleSendToOtherDepartment = async (saleId) => {
        try {
            const response = await generateDispatchNewInstallationPdf(saleId);
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `StoreRecord_${saleId}.pdf`;
            a.click();
        } catch (error) {
            console.error('Error:', error);
            console.error('Failed to generate PDF');
        }
    };
    const showSnackbar = (message, severity) => {
        setSnackbar({ open: true, message, severity });
    };

    const handleSnackbarClose = () => {
        setSnackbar({ ...snackbar, open: false });
    };
    const [storeData, setStoreData] = React.useState([])
    const [modalOpen, setModalOpen] = React.useState(false);
    // Save storeData to localStorage on update
    React.useEffect(() => {
        localStorage.setItem('store', JSON.stringify(storeData));
        console.log(storeData, 'storeData');

    }, [storeData]);

    const handleOpen = () => setModalOpen(true);
    const handleClose = () => setModalOpen(false);
    const [editModalOpen, setEditModalOpen] = React.useState(false);
    const [selectedStore, setSelectedStore] = React.useState(null);
    const handleEditOn = (device) => {
        setSelectedStore(device);
        setEditModalOpen(true);
    };

    const handleEditClose = () => {
        setEditModalOpen(false);
        setSelectedStore(null);
    };
const handleStatusChange = async (saleId, newStatus, sale) => {
    const updatedSale = { ...sale, status: newStatus };

    try {
        await updateDispatchNewInstallation(saleId, updatedSale);

        // Update state in frontend
        setStoreData((prevData) =>
            prevData.map((item) =>
                item.id === saleId ? { ...item, status: newStatus } : item
            )
        );

        showSnackbar('Status updated successfully', 'success');
    } catch (error) {
        console.error('Failed to update status:', error);
        showSnackbar('Failed to update status', 'error');
    }
};
    const handleDelete = async (id) => {
        try {
            await api.delete(`/dispatch-new-installation/${id}/`);
            showSnackbar("Customer deleted successfully", "success");
        } catch (error) {
            showSnackbar("Failed to delete customer", "error");
            console.error(error);
        }
    };

    const handleSave = async (newEmployee) => {
        try {
            const response = await api.post('/dispatch-new-installation/', newEmployee);
            setStoreData((prev) => [...prev, response.data]);
        } catch (error) {
            console.error("Error saving employee:", error);
        }
    };

    const handleExport = () => {
  const doc = new jsPDF('l', 'mm', 'a3');

  // Title
  doc.setFontSize(18);
  doc.text('Store New Installation Report', 14, 16);

  // Columns (aligned with UI table headers)
  const columns = [
    'Store #',
    'Production #',
    'Document',
    'Remarks',
    'Close At',
  ];

  // Table Data (map storeData properly)
  const tableData = storeData.map((sale) => [
    sale.id,  // Store #
    sale.production,  // Production #
    sale.document_url ? 'Available' : 'Not Available', // or full link if needed
    sale.remarks || '',
    sale.status === 'Close'
      ? sale.updated_at?.slice(0, 19).replace('T', ' ')
      : '',
  ]);

  // Generate table
  doc.autoTable({
    head: [columns],
    body: tableData,
    startY: 30,
    styles: {
      fontSize: 9,
      cellPadding: 2,
    },
    columnStyles: {
      0: { cellWidth: 30 },  // Store #
      1: { cellWidth: 30 },  // Production #
      2: { cellWidth: 40 },  // Document
      3: { cellWidth: 70 },  // Remarks
      4: { cellWidth: 40 },  // Close At
    },
    theme: 'grid',
    didDrawPage: function () {
      doc.setFontSize(18);
      doc.text('Store Report', 14, 16);
    },
  });

  doc.save('Store_New_Installation_Report.pdf');
};
    const EditStoreModal = ({ open, handleClose, device }) => (
        <FormModal
            open={open}
            onClose={handleClose}
            title="Edit Store"
            schema={z.object({ remarks: z.string().optional() })}
            defaultValues={{ remarks: device?.remarks ?? "" }}
            onSubmit={async (data) => {
                const payload = new FormData();
                Object.entries(data).forEach(([k, v]) => {
                    if (v !== null && v !== undefined && v !== "") payload.append(k, v);
                });
                try {
                    await updateDispatchNewInstallation(device.id, payload);
                    showSnackbar("Store updated successfully", "success");
                    fetchTrucks();
                } catch (err) {
                    showSnackbar("Store update failed", "error");
                    throw err;
                }
            }}
            submitLabel="Update"
            width={400}
        >
            {({ control }) => (
                <>
                    <Box sx={{ mb: 2, display: "flex", gap: 3, flexWrap: "wrap" }}>
                        <Typography variant="body2" color="text.secondary">
                            Updated At: {device?.updated_at?.slice(0, 19).replace("T", " ")}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Created At: {device?.created_at?.slice(0, 19).replace("T", " ")}
                        </Typography>
                    </Box>
                    <Grid container spacing={2.5}>
                        <Grid item xs={12}>
                            <RHFTextField control={control} name="remarks" label="Remarks" multiline rows={3} />
                        </Grid>
                    </Grid>
                </>
            )}
        </FormModal>
    );

    const updateStore = async (updatedStore, id) => {
        const formData = new FormData();
        for (const key in updatedStore) {
            formData.append(key, updatedStore[key]);
        }
        try {
            await updateDispatchNewInstallation(id, formData);
            showSnackbar('Store updated successfully', 'success');
        } catch (error) {
            showSnackbar('Failed to update device', 'error');
        }
    };
    return (
        <Container maxWidth="xl" sx={{ m: 2 }}>
            {editModalOpen && selectedStore && <EditStoreModal
                open={editModalOpen}
                handleClose={handleEditClose}
                device={selectedStore}
            />}
            <DataTable
                title="Store New Installation List"
                columns={[
                    { key: 'id', label: 'Store #' },
                    { key: 'production', label: 'Production #', render: (sale) => (
                        <span onClick={() => handleViewCustomerSupportDetail(sale.production)} style={{ color: '#1976d2', textDecoration: 'underline', cursor: 'pointer' }}>{sale.production}</span>
                    )},
                    { key: 'document_url', label: 'Document', render: (sale) => sale.document_url ? (
                        <a href={`https://crm-backend.monit.tech/${sale.document_url}`} download target="_blank" rel="noopener noreferrer">Download</a>
                    ) : <span style={{ color: '#999' }}>Not Available</span> },
                    { key: 'remarks', label: 'Remarks' },
                    { key: 'close_at', label: 'Close At', render: (sale) => (
                        <div style={{ maxHeight: '80px', overflow: 'auto' }}>{sale.status === 'Close' && sale.updated_at?.slice(0, 19).replace("T", " ")}</div>
                    )},
                ]}
                rows={storeData}
                toolbarActions={<Button variant="contained" color="primary" style={{ marginLeft: "10px" }} onClick={handleExport}>Export to PDF</Button>}
                renderActions={(sale) => <>
                    <IconButton color="secondary" size="small" onClick={() => handleEditOn(sale)} sx={{ padding: '6px' }} disabled={sale.status === 'Close'}><EditIcon /></IconButton>
                    <IconButton color="error" size="small" onClick={() => handleDeleteClick(sale.id)} sx={{ padding: '6px', marginLeft: '4px' }} disabled={sale.status === 'Complete'}><DeleteIcon /></IconButton>
                    <IconButton color="primary" size="small" onClick={() => handleSendClick(sale.id)} sx={{ padding: '6px', marginLeft: '4px' }} disabled={sendingEmailId === sale.id}>
                        {sendingEmailId === sale.id ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
                    </IconButton>
                    <Select value={sale.status} onChange={(e) => handleStatusChange(sale.id, e.target.value, sale)} size="small" sx={{ ml: 1, minWidth: 100 }}>
                        <MenuItem value="Pending">Pending</MenuItem>
                        <MenuItem value="Handover">Handover</MenuItem>
                        <MenuItem value="Courier">Courier</MenuItem>
                        <MenuItem value="Carrier">Carrier</MenuItem>
                    </Select>
                </>}
            />
                {/* Delete Confirmation */ }
      <DeleteConfirmDialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        onConfirm={confirmDelete}
      />

      <SendEmailConfirmDialog
        open={sendConfirmOpen}
        onClose={() => setSendConfirmOpen(false)}
        onConfirm={confirmSendEmail}
      />
            <Dialog open={saleModalOpen} onClose={() => setSaleModalOpen(false)} maxWidth="sm" fullWidth>
                            <DialogTitle>Sale Details</DialogTitle>
                            <DialogContent>
                                {selectedSale ? (
            <Box>
              <Typography variant="body1"><strong>Customer:</strong> {haulierOptions[selectedSale.sale.customer]}</Typography>
              <Typography variant="body1"><strong>Solution:</strong> {devicesOptions[selectedSale.sale.solution]}</Typography>
              <Typography variant="body1"><strong>Corporate:</strong> {selectedSale.sale.corporate}</Typography>
              <Typography variant="body1"><strong>POC Name:</strong> {selectedSale.sale.poc_name}</Typography>
            <Typography variant="body1"><strong>POC Contact:</strong> {selectedSale.sale.poc_contact}</Typography>
              <Typography variant="body1"><strong>Plan:</strong> {selectedSale.sale.plan}</Typography>
              <Typography variant="body1"><strong>Unit:</strong> {selectedSale.sale.unit}</Typography>
              <Typography variant="body1"><strong>Features:</strong> {selectedSale.sale.features}</Typography>

            </Box>
          ) : (
            <Typography variant="body2">Loading...</Typography>
          )}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setSaleModalOpen(false)} color="primary">Close</Button>
                            </DialogActions>
                        </Dialog>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
}
